import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BizTabs, { BizTab } from '../../../Core/Components/Mini/BizTabs';
import LeaveOverview from './LeaveOverview';
import LeaveApplicationList from './LeaveApplicationList';
import MonthlyReports from '../TimeEntry/MonthlyReports';
import './TimereportUserYear.scss';

type UserYearTab = 'overview' | 'applications' | 'monthly';

const TimereportUserYear = () => {
	const { t } = useTranslation();
	const [year, setYear] = useState(new Date().getFullYear());
	const [selectedTab, setSelectedTab] = useState<UserYearTab>('overview');

	const tabs: BizTab[] = [
		{ key: 'overview', title: t('TIMEREPORT_USER.OVERVIEW.YEAR.TABS.OVERVIEW_LEAVE') },
		{ key: 'applications', title: t('TIMEREPORT_USER.OVERVIEW.YEAR.TABS.LEAVE_APPLICATIONS') },
		{ key: 'monthly', title: t('TIMEREPORT_USER.OVERVIEW.YEAR.TABS.MONTHLY_REPORTS') },
	];

	const renderContent = () => {
		switch (selectedTab) {
			case 'overview':
				return <LeaveOverview year={year} />;
			case 'applications':
				return <LeaveApplicationList year={year} />;
			case 'monthly':
				return <MonthlyReports year={year} />;
		}
	};

	return (
		<div className='biz-timereport-user-year'>
			<div className='biz-timereport-user-year__year-selector'>
				<button
					className='biz-timereport-user-year__year-btn'
					aria-label={t('TIMEREPORT_USER.OVERVIEW.YEAR.ACTIONS.PREVIOUS_YEAR')}
					onClick={() => setYear((y) => y - 1)}
				>
					‹
				</button>
				<span className='biz-timereport-user-year__year-label'>{year}</span>
				<button
					className='biz-timereport-user-year__year-btn'
					aria-label={t('TIMEREPORT_USER.OVERVIEW.YEAR.ACTIONS.NEXT_YEAR')}
					onClick={() => setYear((y) => y + 1)}
				>
					›
				</button>
			</div>

			<BizTabs
				tabs={tabs}
				selectedTabKey={selectedTab}
				onClick={(key) => setSelectedTab(key as UserYearTab)}
				ariaLabel={t('TIMEREPORT_USER.OVERVIEW.YEAR.NAVIGATION_ARIA')}
				tabPosition='spread'
			/>

			<div className='biz-timereport-user-year__content'>{renderContent()}</div>
		</div>
	);
};

export default TimereportUserYear;
